import { FC, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { Area } from "@prisma/client";

import ExistingFilter from "./existing-filter";

import { ActionType } from "@interfaces/filters";
import { useFilters } from "@context/filter";
import Loader from "@components/common/loader";
import { useStaticData } from "@context/static";

interface Props {
  filtersText: string;
  areaData: Area[];
}

const ActiveFilters: FC<Props> = ({ filtersText, areaData }) => {
  const { filters } = useFilters();
  const router = useRouter();
  const { slug } = router.query;
  const { categories } = useStaticData();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("category", { keyPrefix: "filters" });

  useEffect(() => {
    if (
      Object.keys(router.query).length > 1 &&
      !!slug &&
      !!slug.length &&
      !filters.areasSet.size &&
      !filters.colorSet.size &&
      !filters.stylesSet.size &&
      !filters.materialSet.size &&
      !filters.suppliersSet.size &&
      !filters.priceIsSet &&
      !filters.heightIsSet &&
      !filters.widthIsSet &&
      !filters.lengthIsSet
    ) {
      setLoading(true);
      router
        .push({ pathname: router.pathname, query: { slug } })
        .then(() => router.reload());
    }
  }, [filters, router, slug]);

  return (
    <>
      <Loader {...{ loading }} />
      <div className="flex flex-row flex-wrap justify-center">
        {Array.from(filters.suppliersSet).map((value) => (
          <div key={value}>
            <ExistingFilter
              text={value}
              action={{ type: ActionType.REMOVE_SUPPLIER, value }}
            />
          </div>
        ))}
        {Array.from(filters.colorSet).map((value) => (
          <div key={value}>
            <ExistingFilter
              text={value}
              action={{ type: ActionType.REMOVE_COLOR, value }}
            />
          </div>
        ))}
        {Array.from(filters.materialSet).map((value) => (
          <div key={value}>
            <ExistingFilter
              text={value}
              action={{ type: ActionType.REMOVE_MATERIAL, value }}
            />
          </div>
        ))}
        {Array.from(filters.stylesSet).map((value) => (
          <div key={value}>
            <ExistingFilter
              text={value}
              action={{ type: ActionType.REMOVE_STYLE, value }}
            />
          </div>
        ))}
        {Array.from(filters.areasSet).map((value) => (
          <div key={value}>
            <ExistingFilter
              text={
                router.locale === "en"
                  ? areaData.find(({ name }) => name === value)?.nameEn || ""
                  : areaData.find(({ name }) => name === value)?.name || ""
              }
              action={{ type: ActionType.REMOVE_AREA, value }}
            />
          </div>
        ))}
        {Array.from(filters.areasSet).map((value) => (
          <div key={value}>
            <ExistingFilter
              text={value}
              action={{ type: ActionType.REMOVE_SUPPLIER, value }}
            />
          </div>
        ))}
        {filters.priceIsSet && (
          <ExistingFilter
            text={`${filters.price.join("-")} €`}
            action={{ type: ActionType.CLEAR_PRICE }}
          />
        )}
        {filters.lengthIsSet && (
          <ExistingFilter
            text={`${t("measures.length.label")} ${filters.lengthQuery.join(
              "-"
            )} cm`}
            action={{ type: ActionType.CLEAR_LENGTH }}
          />
        )}
        {filters.heightIsSet && (
          <ExistingFilter
            text={`${t("measures.height.label")} ${filters.heightQuery.join(
              "-"
            )} cm`}
            action={{ type: ActionType.CLEAR_HEIGHT }}
          />
        )}
        {filters.widthIsSet && (
          <ExistingFilter
            text={`${t("measures.width.label")} ${filters.widthQuery.join(
              "-"
            )} cm`}
            action={{ type: ActionType.CLEAR_WIDTH }}
          />
        )}
      </div>
      <div className="text-center">
        {filters.totalNumberOfProducts} {t("products-in")}{" "}
        {
          categories.find((category) => slug.slice(-1)[0] === category.slug)
            ?.name
        }
        . {filtersText}
      </div>
    </>
  );
};
export default ActiveFilters;
